module.exports = __webpack_public_path__ + "static/img/accesos1.be2b060f.jpg";